import { CellProps, Renderer } from "react-table";

export const PhoneCell: <T extends object>() => Renderer<CellProps<T, unknown>> = 
    () => {
        return (props) => props.value ? (
            <a href={`tel:${props.value}`}>
                {props.value as string}
            </a>
        ) : (<></>)
}